import { createContext, useContext } from "react";

// The real navigation type, PUSH, REPLACE or POP, for the page on screen.
//
// Pages render inside PageTransition's <Routes location={displayLocation}>
// (App.jsx), and React Router reports POP for routes rendered with a location
// of their own, always: useRoutes wraps them in a fresh LocationContext with
// navigationType: Action.Pop. So useNavigationType() read inside a page was
// POP whatever happened, and anything keyed on it never ran. FeaturedPage's
// scroll-to-top on arrival skips POP (back and forward) on purpose, so it
// skipped every arrival, and coming from a scrolled home page left the
// catalog at the bottom. PageTransition sits outside those Routes, reads the
// real type and provides it here.
export const AppNavigationTypeContext = createContext("POP");

/** useNavigationType() for pages: the real type, not the scoped Routes' POP. */
export function useAppNavigationType() {
  return useContext(AppNavigationTypeContext);
}
